<div class="cookie-banner">
  <div class="cookie-icon-container">
    <div class="icon-circle">
      <i class="bi bi-cookie"></i>
    </div>
  </div>
  
  <div class="cookie-text">
    <h2 class="cookie-title">We use cookies</h2>
    <p class="cookie-description">
      We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
      By clicking "Accept All", you consent to our use of cookies. 
      You can manage your preferences or learn more in our <a href="/pdfs/Privacy Policy.pdf" target="_blank" class="">Cookie Policy</a>.
    </p>
  </div>

  <div class="cookie-actions">
    <button class="btn-manage" (click)="managePreferences()">Manage Preferences</button>
    <button class="btn-accept" (click)="acceptAll()">Accept All</button>
  </div>
</div>
